import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SubscriptionTemplateLinkUpdateInput } from '../generated/globalTypes';
import { updateSubscriptionTemplateLinkMutation, updateSubscriptionTemplateLinkMutationVariables } from '../generated/updateSubscriptionTemplateLinkMutation';
import { subscriptionTemplateLinkFieldsFragment } from '../models/SubscriptionTemplateLink';

/**
 * Get a callback to update a SubscriptionTemplateLink in the store.
 */
export function useUpdateSubscriptionTemplateLinkCallback(): [(id: string, model: SubscriptionTemplateLinkUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateSubscriptionTemplateLinkMutation, updateSubscriptionTemplateLinkMutationVariables>(
        gql`
            mutation updateSubscriptionTemplateLinkMutation ($model: SubscriptionTemplateLinkUpdateInput!) {
                updateSubscriptionTemplateLink(model: $model) {
                    ...subscriptionTemplateLinkFields
                }
            }

            ${subscriptionTemplateLinkFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: SubscriptionTemplateLinkUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
